// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';
import { THANKYOU_ICON_FILL_COLOUR } from '../../../../../constants/brandSpecific.constants';

const styles = css`
  width: 100%;
  .l3-nav-carousel-container {
    display: inline-block;
    width: 94px;
    height: 144px;
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
    box-shadow: 0 ${(props) => props.theme.spacing.ELEM_SPACING.XXXS}
      ${(props) => props.theme.spacing.ELEM_SPACING.XS} 0 rgba(0, 0, 0, 0.15);
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS} 14px
      ${(props) => props.theme.spacing.ELEM_SPACING.MED}
      ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
    vertical-align: top;
    :first-child {
      margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 100px;
      height: 131px;
      :first-child {
        margin-left: 13px;
      }
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 92px;
      height: 121px;
      :first-child {
        margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
      }
    }
  }
  .l3-nav-carousel-container-new {
    display: inline-block;
    vertical-align: top;
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 181px;
    }
  }
  .container-carousel {
    background-color: #e1e1e1;
    white-space: nowrap;
    -ms-overflow-style: none;
    scrollbar-width: none;
    @media ${(props) => props.theme.mediaQuery.large} {
      width: calc(100% - 10px);
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      > div {
        margin: 0px 0 32px 0;
      }
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      > div {
        margin: 4px 0 20px 8px;
      }
    }

    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding-left: 8px;
      > div {
        margin: 0 0 5px 0;
        padding: 0px 0px 5px 0;
      }
    }
  }
  .container-carousel.new-container {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: 290px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 314px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 326px;
    }
  }
  .tcp_carousel_wrapper {
    @media ${(props) => props.theme.mediaQuery.large} {
      padding-left: 24px;
    }
  }
  .sbc-main {
    display: flex;
    flex-direction: column;
    width: min-content;
    border: 2px solid rgb(218, 216, 216);
    border-radius: 8px;
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      margin: 0 6px 0 0;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin: 0 6px 0 0;
    }
    &.selected-filter-new {
      border: solid 2px ${(props) => THANKYOU_ICON_FILL_COLOUR[props?.brandId?.toUpperCase()]};
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      :hover {
        border: solid 2px ${(props) => THANKYOU_ICON_FILL_COLOUR[props?.brandId?.toUpperCase()]};
      }
    }
  }
  .container-carousel.new-container.few-items {
    display: flex;
    justify-content: center;
  }
  .container-carousel::-webkit-scrollbar {
    display: none;
  }
  .image-container {
    width: 77px;
    height: 97px;
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.XS}
      ${(props) => props.theme.spacing.ELEM_SPACING.XS}
      ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 59px;
      height: 74px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 55px;
      height: 68px;
      margin: 9px 19px ${(props) => props.theme.spacing.ELEM_SPACING.XXS} 18px;
    }
  }
  .image-container-new {
    width: 118px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 100%;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      width: 165.04px;
      height: 100%;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 148px;
      height: 100%;
    }
  }
  .item-container {
    white-space: nowrap;
    margin-left: -14px;
    position: relative;
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-left: 0;
    }
  }
  .item-container-new {
    white-space: nowrap;
    position: relative;
    margin-bottom: 10px;
    @media ${(props) => props.theme.mediaQuery.large} {
      margin: 0 auto;
      width: calc(100% - 4px);
    }

    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      margin-left: -2px;
    }
    .slick-next {
      right: 19px;
      top: -40px;
      width: 18px;
      height: 21px;
      padding: 19px;
      background: url(${(props) => getIconPath('arrow-right-small', props)}) no-repeat center center;
      border-radius: 100%;
    }
    .slick-prev {
      top: -40px;
      left: calc(100% - 105px);
      background: url(${(props) => getIconPath('arrow-right-small', props)}) no-repeat center center;
      border-radius: 100%;
      padding: 19px;
    }
    .slick-slide > div > div {
      text-align: left;
    }
  }
  .sbc-plp {
    overflow-y: hidden;
    padding-top: 18px;
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-left: 0;
      width: calc(100% - 4px);
      margin-bottom: 20px;
      .slick-prev {
        left: calc(100% - 105px);
      }
    }
  }
  .title-container {
    white-space: normal;
    height: 38px;
  }
  .title-container-new {
    white-space: normal;
    height: 48px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    background-color: #162f42;
    border-radius: 0 0 6px 6px;
    padding: 0 4px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: 41px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 41px;
    }
  }
  .title-container-new p {
    color: ${(props) => props.theme.colors.WHITE};
    font-weight: 700;
    line-height: 1rem;
    font-size: ${(props) => props.theme.typography.fontSizes.fs12};
    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    }
  }
  .image-link-new {
    display: block;
    width: 100%;
    margin: auto;
    background-color: transparent;
    border-radius: 6px 6px 0 0;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 145.04px;
      height: 180px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      width: 100%;
      height: 205.2px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      min-height: 182px;
    }
  }
  .plp-carousel-banner-text {
    margin-top: 4px;
  }
  .img-reactangle {
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
  }
  .carousel-image-new {
    height: 100%;
    border-radius: 6px 6px 0 0;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      position: relative;
    }
  }
  .sbc-heading {
    font-weight: 800;
    text-transform: capitalize;
    text-align: center;
    line-height: 18px;
    letter-spacing: 0.01em;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs20};
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs16};
      height: unset;
      padding-top: 15px;
      margin-bottom: 15px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      font-size: 16px;
      padding-top: 15px;
      margin-bottom: 15px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs16};
      padding-top: 24px;
      margin-bottom: 24px;
    }
  }

  .multiline-ellipsis {
    text-transform: capitalize;
  }
  .sbc-mobile {
    overflow-x: scroll;
    display: flex;
    ::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  &.sbc-redesign {
    background-color: rgb(243 243 243) !important;
    margin-bottom: 20px;
    padding-bottom: 24px;
    .image-link p {
      background-color: #162f42;
      color: #ffffff;
      white-space: break-spaces;
      font-size: 13px !important;
      margin: 0 !important;
      font-weight: 700;
      padding: 8px 20px !important;
      height: 31px;
      justify-content: center;
      align-items: center;
      line-clamp: 2;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: horizontal;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: normal;
      letter-spacing: normal;
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
      @media (max-width: 1199px) {
        font-size: 12px !important;
        padding: 5px 3.5px !important;
      }
    }
    .container-carousel {
      overflow-x: scroll;
      overflow-y: hidden;
      white-space: unset;
      width: 100%;
      -ms-overflow-style: none;
      height: 290px;
    }
    .container-carousel.new-container {
      height: auto;
    }
    .container-carousel::-webkit-scrollbar {
      display: none;
    }
    .carousel-inner-container {
      display: inline-block;
      width: 177px;
    }
    .slick-list {
      max-width: 100%;
    }

    @media ${(props) => props.theme.mediaQuery.large} {
      .container-carousel-desktop {
        width: 100%;
      }
      .tcp_carousel_wrapper {
        padding-left: 0px;
      }
    }
    .heading {
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
      text-align: center;
    }
    .subheading {
      text-align: center;
      padding-left: 28px;
      padding-right: 28px;
      padding-top: 24px;
      font-weight: 800;
      font-size: 16px;
      line-height: 18px;
      letter-spacing: 0.01em;
      color: #1a1a1a;
      margin-bottom: 24px !important;
      text-transform: capitalize;
    }
    .slick-arrow {
      top: calc(50% - 20px);
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      .heading {
        margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
      }
    }
    .tile-container {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      @media (min-width: 1200px) {
        width: 148px !important;
      }
      border: 2px solid #dad8d8 !important;
      border-radius: 6px;
      @media (max-width: 1199px) {
        left: 0px;
        top: 0px;
        border: 1px solid #dad8d8;
        border-radius: 6px;
        margin-right: 5px !important;
        width: 100%;
      }
    }
    .carousel-image {
      @media (max-width: 1199px) {
        margin: 0 auto -6px;
      }
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
    }

    .container-carousel .tile-container {
      @media (max-width: 1200px) {
        margin: 0 0 0 5px !important;
      }
    }
    .tile-container .carousel-image {
      @media (max-width: 350px) {
        height: 149px !important;
        min-width: 120.04px !important;
      }
      @media (min-width: 351px) and (max-width: 409px) {
        height: 180px !important;
        min-width: 145.04px !important;
      }
      @media (min-width: 410px) and (max-width: 767px) {
        height: 205px !important;
        min-width: 165.04px !important;
      }
      @media (min-width: 768px) and (max-width: 1199px) {
        min-width: 165.04px !important;
      }
    }

    @media (max-width: 1199px) {
      margin-bottom: 14px;
      padding-bottom: 10px;
      .subheading + div::before {
        display: none !important;
      }
      .container-carousel {
        padding-left: 0 !important;
        border: none !important;
      }
      .subheading + div {
        margin-left: 0 !important;
      }
      .subheading {
        padding-top: 15px;
        margin-bottom: 15px !important;
        margin-top: 0px !important;
      }
      .tile-container .image-container {
        min-height: 180px;
        min-width: 165px;
      }
    }
    @media (max-width: 350px) {
      .tile-container .image-container {
        min-height: 149px;
        min-width: 120px;
      }
    }
    @media (min-width: 1200px) {
      .slick-slider {
        margin-left: 1% !important;
        margin-right: 1% !important;
      }
      .tile-container .image-container {
        min-height: 182px;
      }
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      .tile-container .image-container {
        min-height: 204px;
      }
    }
    .slick-next {
      top: -31px;
      width: 18px;
      height: 21px;
      right: 14px;
      background: white url(${(props) => getIconPath('family-outfit-arrow', props)}) no-repeat
        center center;
      border-radius: 100%;
      padding: 19px;
      background-size: 6px;
      min-height: 38px;
    }

    .slick-prev {
      top: -31px;
      width: 18px;
      height: 21px;
      left: unset;
      right: 65px;
      background: url(${(props) => getIconPath('family-outfit-arrow', props)}) white no-repeat
        center center;
      border-radius: 100%;
      padding: 19px;
      background-size: 6px;
      min-height: 38px;
    }
    .slick-disabled {
      filter: opacity(50%);
    }

    .slick-slide > div > div:nth-child(1):hover,
    .slick-slide > div > div:nth-child(1):focus,
    .slick-slide > div > div:nth-child(1):active,
    .slick-slide > div > div:nth-child(1).clicked {
      border: 2px solid ${(props) => props.theme.colors.BRAND.PRIMARY} !important;
    }
    .image-container {
      width: unset;
      height: unset;
      margin: unset;
    }

    .sbc-plp {
      padding-top: unset;
      margin-bottom: unset;
    }
    .sbc-heading {
      border-bottom: unset;
      padding-bottom: unset;
    }
    .sbc-mobile {
      display: flex !important;
      margin-bottom: 0px;
    }
  }

  .desktop-carousel .slick-list {
    @media ${(props) => props.theme.mediaQuery.large} {
      max-height: 260px;
    }
  }
`;

export default styles;
